import { render, staticRenderFns } from "./taskDetail.vue?vue&type=template&id=e16f6dda&scoped=true&"
import script from "./taskDetail.vue?vue&type=script&lang=tsx&"
export * from "./taskDetail.vue?vue&type=script&lang=tsx&"
import style0 from "./taskDetail.vue?vue&type=style&index=0&id=e16f6dda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16f6dda",
  null
  
)

export default component.exports